/**
 * This file was automatically generated by an automated script. Do not edit manually.
 */
import type { ModelProfile } from "@langchain/core/language_models/profile";
const PROFILES: Record<string, ModelProfile> = {
  "claude-opus-4-0": {
    maxInputTokens: 200000,
    imageInputs: true,
    audioInputs: false,
    pdfInputs: true,
    videoInputs: false,
    maxOutputTokens: 32000,
    reasoningOutput: true,
    imageOutputs: false,
    audioOutputs: false,
    videoOutputs: false,
    toolCalling: true,
    structuredOutput: false,
    imageUrlInputs: true,
    pdfToolMessage: true,
    imageToolMessage: true,
  },
  "claude-3-5-sonnet-20241022": {
    maxInputTokens: 200000,
    imageInputs: true,
    audioInputs: false,
    pdfInputs: true,
    videoInputs: false,
    maxOutputTokens: 8192,
    reasoningOutput: false,
    imageOutputs: false,
    audioOutputs: false,
    videoOutputs: false,
    toolCalling: true,
    structuredOutput: false,
    imageUrlInputs: true,
    pdfToolMessage: true,
    imageToolMessage: true,
  },
  "claude-opus-4-1": {
    maxInputTokens: 200000,
    imageInputs: true,
    audioInputs: false,
    pdfInputs: true,
    videoInputs: false,
    maxOutputTokens: 32000,
    reasoningOutput: true,
    imageOutputs: false,
    audioOutputs: false,
    videoOutputs: false,
    toolCalling: true,
    structuredOutput: false,
    imageUrlInputs: true,
    pdfToolMessage: true,
    imageToolMessage: true,
  },
  "claude-haiku-4-5": {
    maxInputTokens: 200000,
    imageInputs: true,
    audioInputs: false,
    pdfInputs: true,
    videoInputs: false,
    maxOutputTokens: 64000,
    reasoningOutput: true,
    imageOutputs: false,
    audioOutputs: false,
    videoOutputs: false,
    toolCalling: true,
    structuredOutput: false,
    imageUrlInputs: true,
    pdfToolMessage: true,
    imageToolMessage: true,
  },
  "claude-sonnet-4-6": {
    maxInputTokens: 200000,
    imageInputs: true,
    audioInputs: false,
    pdfInputs: true,
    videoInputs: false,
    maxOutputTokens: 64000,
    reasoningOutput: true,
    imageOutputs: false,
    audioOutputs: false,
    videoOutputs: false,
    toolCalling: true,
    structuredOutput: false,
    imageUrlInputs: true,
    pdfToolMessage: true,
    imageToolMessage: true,
  },
  "claude-3-5-sonnet-20240620": {
    maxInputTokens: 200000,
    imageInputs: true,
    audioInputs: false,
    pdfInputs: true,
    videoInputs: false,
    maxOutputTokens: 8192,
    reasoningOutput: false,
    imageOutputs: false,
    audioOutputs: false,
    videoOutputs: false,
    toolCalling: true,
    structuredOutput: false,
    imageUrlInputs: true,
    pdfToolMessage: true,
    imageToolMessage: true,
  },
  "claude-opus-4-6": {
    maxInputTokens: 200000,
    imageInputs: true,
    audioInputs: false,
    pdfInputs: true,
    videoInputs: false,
    maxOutputTokens: 128000,
    reasoningOutput: true,
    imageOutputs: false,
    audioOutputs: false,
    videoOutputs: false,
    toolCalling: true,
    structuredOutput: false,
    imageUrlInputs: true,
    pdfToolMessage: true,
    imageToolMessage: true,
  },
  "claude-3-5-haiku-latest": {
    maxInputTokens: 200000,
    imageInputs: true,
    audioInputs: false,
    pdfInputs: true,
    videoInputs: false,
    maxOutputTokens: 8192,
    reasoningOutput: false,
    imageOutputs: false,
    audioOutputs: false,
    videoOutputs: false,
    toolCalling: true,
    structuredOutput: false,
    imageUrlInputs: true,
    pdfToolMessage: true,
    imageToolMessage: true,
  },
  "claude-opus-4-5": {
    maxInputTokens: 200000,
    imageInputs: true,
    audioInputs: false,
    pdfInputs: true,
    videoInputs: false,
    maxOutputTokens: 64000,
    reasoningOutput: true,
    imageOutputs: false,
    audioOutputs: false,
    videoOutputs: false,
    toolCalling: true,
    structuredOutput: false,
    imageUrlInputs: true,
    pdfToolMessage: true,
    imageToolMessage: true,
  },
  "claude-3-opus-20240229": {
    maxInputTokens: 200000,
    imageInputs: true,
    audioInputs: false,
    pdfInputs: true,
    videoInputs: false,
    maxOutputTokens: 4096,
    reasoningOutput: false,
    imageOutputs: false,
    audioOutputs: false,
    videoOutputs: false,
    toolCalling: true,
    structuredOutput: false,
    imageUrlInputs: true,
    pdfToolMessage: true,
    imageToolMessage: true,
  },
  "claude-opus-4-5-20251101": {
    maxInputTokens: 200000,
    imageInputs: true,
    audioInputs: false,
    pdfInputs: true,
    videoInputs: false,
    maxOutputTokens: 64000,
    reasoningOutput: true,
    imageOutputs: false,
    audioOutputs: false,
    videoOutputs: false,
    toolCalling: true,
    structuredOutput: false,
    imageUrlInputs: true,
    pdfToolMessage: true,
    imageToolMessage: true,
  },
  "claude-sonnet-4-5": {
    maxInputTokens: 200000,
    imageInputs: true,
    audioInputs: false,
    pdfInputs: true,
    videoInputs: false,
    maxOutputTokens: 64000,
    reasoningOutput: true,
    imageOutputs: false,
    audioOutputs: false,
    videoOutputs: false,
    toolCalling: true,
    structuredOutput: false,
    imageUrlInputs: true,
    pdfToolMessage: true,
    imageToolMessage: true,
  },
  "claude-sonnet-4-5-20250929": {
    maxInputTokens: 200000,
    imageInputs: true,
    audioInputs: false,
    pdfInputs: true,
    videoInputs: false,
    maxOutputTokens: 64000,
    reasoningOutput: true,
    imageOutputs: false,
    audioOutputs: false,
    videoOutputs: false,
    toolCalling: true,
    structuredOutput: false,
    imageUrlInputs: true,
    pdfToolMessage: true,
    imageToolMessage: true,
  },
  "claude-sonnet-4-20250514": {
    maxInputTokens: 200000,
    imageInputs: true,
    audioInputs: false,
    pdfInputs: true,
    videoInputs: false,
    maxOutputTokens: 64000,
    reasoningOutput: true,
    imageOutputs: false,
    audioOutputs: false,
    videoOutputs: false,
    toolCalling: true,
    structuredOutput: false,
    imageUrlInputs: true,
    pdfToolMessage: true,
    imageToolMessage: true,
  },
  "claude-opus-4-20250514": {
    maxInputTokens: 200000,
    imageInputs: true,
    audioInputs: false,
    pdfInputs: true,
    videoInputs: false,
    maxOutputTokens: 32000,
    reasoningOutput: true,
    imageOutputs: false,
    audioOutputs: false,
    videoOutputs: false,
    toolCalling: true,
    structuredOutput: false,
    imageUrlInputs: true,
    pdfToolMessage: true,
    imageToolMessage: true,
  },
  "claude-3-5-haiku-20241022": {
    maxInputTokens: 200000,
    imageInputs: true,
    audioInputs: false,
    pdfInputs: true,
    videoInputs: false,
    maxOutputTokens: 8192,
    reasoningOutput: false,
    imageOutputs: false,
    audioOutputs: false,
    videoOutputs: false,
    toolCalling: true,
    structuredOutput: false,
    imageUrlInputs: true,
    pdfToolMessage: true,
    imageToolMessage: true,
  },
  "claude-3-haiku-20240307": {
    maxInputTokens: 200000,
    imageInputs: true,
    audioInputs: false,
    pdfInputs: true,
    videoInputs: false,
    maxOutputTokens: 4096,
    reasoningOutput: false,
    imageOutputs: false,
    audioOutputs: false,
    videoOutputs: false,
    toolCalling: true,
    structuredOutput: false,
    imageUrlInputs: true,
    pdfToolMessage: true,
    imageToolMessage: true,
  },
  "claude-3-7-sonnet-20250219": {
    maxInputTokens: 200000,
    imageInputs: true,
    audioInputs: false,
    pdfInputs: true,
    videoInputs: false,
    maxOutputTokens: 64000,
    reasoningOutput: true,
    imageOutputs: false,
    audioOutputs: false,
    videoOutputs: false,
    toolCalling: true,
    structuredOutput: false,
    imageUrlInputs: true,
    pdfToolMessage: true,
    imageToolMessage: true,
  },
  "claude-3-7-sonnet-latest": {
    maxInputTokens: 200000,
    imageInputs: true,
    audioInputs: false,
    pdfInputs: true,
    videoInputs: false,
    maxOutputTokens: 64000,
    reasoningOutput: true,
    imageOutputs: false,
    audioOutputs: false,
    videoOutputs: false,
    toolCalling: true,
    structuredOutput: false,
    imageUrlInputs: true,
    pdfToolMessage: true,
    imageToolMessage: true,
  },
  "claude-sonnet-4-0": {
    maxInputTokens: 200000,
    imageInputs: true,
    audioInputs: false,
    pdfInputs: true,
    videoInputs: false,
    maxOutputTokens: 64000,
    reasoningOutput: true,
    imageOutputs: false,
    audioOutputs: false,
    videoOutputs: false,
    toolCalling: true,
    structuredOutput: false,
    imageUrlInputs: true,
    pdfToolMessage: true,
    imageToolMessage: true,
  },
  "claude-opus-4-1-20250805": {
    maxInputTokens: 200000,
    imageInputs: true,
    audioInputs: false,
    pdfInputs: true,
    videoInputs: false,
    maxOutputTokens: 32000,
    reasoningOutput: true,
    imageOutputs: false,
    audioOutputs: false,
    videoOutputs: false,
    toolCalling: true,
    structuredOutput: false,
    imageUrlInputs: true,
    pdfToolMessage: true,
    imageToolMessage: true,
  },
  "claude-3-sonnet-20240229": {
    maxInputTokens: 200000,
    imageInputs: true,
    audioInputs: false,
    pdfInputs: true,
    videoInputs: false,
    maxOutputTokens: 4096,
    reasoningOutput: false,
    imageOutputs: false,
    audioOutputs: false,
    videoOutputs: false,
    toolCalling: true,
    structuredOutput: false,
    imageUrlInputs: true,
    pdfToolMessage: true,
    imageToolMessage: true,
  },
  "claude-haiku-4-5-20251001": {
    maxInputTokens: 200000,
    imageInputs: true,
    audioInputs: false,
    pdfInputs: true,
    videoInputs: false,
    maxOutputTokens: 64000,
    reasoningOutput: true,
    imageOutputs: false,
    audioOutputs: false,
    videoOutputs: false,
    toolCalling: true,
    structuredOutput: false,
    imageUrlInputs: true,
    pdfToolMessage: true,
    imageToolMessage: true,
  },
};
export default PROFILES;
